'use client';

import { useIsMobile } from '@/hooks/use-is-mobile';
import { Footer } from './footer';
export const ReadyToShip = () => {
  const { isMobile } = useIsMobile();

  return (
    <div className=' w-full bg-white pb-[40px] lg_pb-[60px]'>
      <div className='container mx-auto mb-[20px]'>
        <p className=' mb-[10px] px-[12px] font-teko-medium text-[28px] uppercase leading-[28px] text-primary lg_px-0 lg_text-[40px] lg_leading-[40px]'>
          Ready to explore?
        </p>

        <p className='mt-[10px]  px-[12px] text-left font-roboto-regular text-[16px] leading-[24px] text-primary lg_px-0 lg_text-[18px] lg_leading-[30px]'>
          Discover our latest collection or sign up for exclusive updates on new products and outdoor adventures.
        </p>
      </div>
      <Footer />
    </div>
  );
};
